export function parseTo<Destiny, Source = unknown>(model: Source): Destiny {
  return model as unknown as Destiny;
}
